// extracted by mini-css-extract-plugin
export default {"banner":"banner_top_banner__pJVQf"};